import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import Header from '../../components/Header';
import TabbedPageControl from '../../components/TabbedPageControl';
import Users from './Users';
import Teams from './Teams';
import './Directory.scss';

export class Directory extends React.Component {
  constructor(props) {
    super(props);

    // constants for tab names
    this.usersTab = 'users';
    this.teamsTab = 'teams';

    this.state = {
      selectedTabName: '',
    };
    this.selectTab = this.selectTab.bind(this);

  }

  componentDidMount() {
    this.checkSelectTab();
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkSelectTab();
  }

  checkSelectTab() {
    let { selectedTabName } = this.state;
    const pathParts = this.props.history.getCurrentLocation().pathname.split('/');
    if (pathParts.length > 2) {
      selectedTabName = pathParts[2];
    }
    else {
      selectedTabName = 'users';
    }
    if (selectedTabName != this.state.selectedTabName) {
      this.setState({ selectedTabName });
    }
  }

  selectTab(tabName) {
    this.props.history.replace('/directory/' + tabName);
  }

  render() {
    const { selectedTabName } = this.state;
    let tabContent = null;
    let tabItems = null;
    if (this.props.permissions && (this.props.permissions.isSuperUser || this.props.currentUser.role.name == 'admin' || this.props.currentUser.role.name == 'editor')) {
      tabContent = selectedTabName == this.usersTab ? <Users /> : <Teams />;
      tabItems = [this.usersTab, this.teamsTab];
    }
    else {
      tabContent = <Users />;
      tabItems = [this.usersTab];
    }

    if (this.props.permissions && !this.props.permissions.canViewDirectory) {
      this.props.history.push({ pathname: '/' });
      return null;
    }

    return (
      <div className='directory-container'>
        <Header currentUser={this.props.currentUser} selectedPage="directory" />

        <div className='directory-container__tabs'>

          <TabbedPageControl
            tabItems={tabItems}
            selectedTabName={selectedTabName}
            handleClick={this.selectTab}
          />
          <div className='directory-container__content'>
            {tabContent}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    permissions: state.new_users.permissions,
    currentUser: state.new_users.currentUser,
  };
};

export default withRouter(connect(mapStateToProps)(Directory));



// WEBPACK FOOTER //
// ./src/containers/Directory/index.js